import { createContext, useContext } from "react";

import { guessContentType } from "../components/Files/files";
import type { components } from "../generated/forms-api";

import type { Answer } from "./answers";
import type { AnswerSuggestion } from "./prefill";

export type UploadedFile = { fileName: string; fileId: string };

export type FileSuggestions = components["schemas"]["FileSuggestions"];

export type FileActions = {
    upload: (key: string, answer: Answer | undefined, file: File) => Promise<UploadedFile>;
    download: (key: string, fileName: string) => Promise<void>;
    remove: (key: string, fileName: string) => Promise<void>;
    suggest: (fileId: string) => Promise<FileSuggestions>;
    suggestAnswers: (key: string, files: UploadedFile[]) => Promise<AnswerSuggestion[]>;
};

export const FileActionsContext = createContext<FileActions | undefined>(undefined);

export const useFileActions = () => useContext(FileActionsContext);

const VIEWABLE = ["application/pdf", "image/png", "image/jpeg", "text/plain"];

export const showFile = (blob: Blob, fileName: string) => {
    const type = guessContentType(fileName);
    const viewable = VIEWABLE.includes(type);
    const blobUrl = window.URL.createObjectURL(viewable ? new Blob([blob], { type }) : blob);
    const tab = viewable ? window.open(blobUrl, "_blank") : null;
    if (tab) {
        tab.opener = null;
    } else {
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
    window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60_000);
};
